export default "__VITE_ASSET__CBZEw5UC__"